import { render, staticRenderFns } from "./absent.vue?vue&type=template&id=5b0d157c&scoped=true&"
import script from "./absent.vue?vue&type=script&lang=js&"
export * from "./absent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d157c",
  null
  
)

export default component.exports